import { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import api from "@/lib/api";

const day = (iso) => new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" });

export function PrintHistory({ storeId, days = 14 }) {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    setStats(null);
    api.printAgentJobStats(storeId, days).then(setStats).catch(() => setStats({ days: [], stores: [], totals: {} }));
    const t = setInterval(() => api.printAgentJobStats(storeId, days).then(setStats).catch(() => {}), 30000);
    return () => clearInterval(t);
  }, [storeId, days]);
  if (!stats) return <p className="text-xs text-muted-foreground">Caricamento storico…</p>;
  const max = Math.max(1, ...stats.days.map((d) => d.done + d.failed));
  return (
    <div className="space-y-3" data-testid="print-history">
      <h3 className="text-sm font-semibold flex items-center gap-2"><BarChart3 className="h-4 w-4 text-primary" /> Ricevute stampate al giorno · ultimi {days} giorni
        <span className="text-muted-foreground font-normal">· {stats.totals.done ?? 0} stampate, {stats.totals.failed ?? 0} in errore</span></h3>
      <div className="flex items-end gap-1 h-24" data-testid="print-history-bars">
        {stats.days.map((d) => (
          <div key={d.date} className="flex-1 flex flex-col items-center justify-end gap-1 group" title={`${day(d.date)}: ${d.done} stampate, ${d.failed} errori`}>
            <span className="text-[10px] text-muted-foreground opacity-0 group-hover:opacity-100">{d.done}</span>
            <div className="w-full rounded-t-sm bg-emerald-500/80" style={{ height: `${(d.done / max) * 64}px` }} />
            {d.failed > 0 && <div className="w-full bg-red-500/80" style={{ height: `${(d.failed / max) * 64}px` }} />}
            <span className="text-[9px] text-muted-foreground">{day(d.date).slice(0, 5)}</span>
          </div>
        ))}
      </div>
      {!storeId && stats.stores.length > 0 && (
        <div className="grid sm:grid-cols-2 gap-2 text-xs" data-testid="print-history-stores">
          {stats.stores.map((s) => (
            <div key={s.store_id || "none"} className="flex items-center justify-between rounded-md bg-secondary/40 px-3 py-1.5">
              <span className="font-semibold">{s.store_name}</span>
              <span className="text-muted-foreground"><span className="text-emerald-400">{s.done}</span> stampate{s.failed ? <> · <span className="text-red-400">{s.failed}</span> errori</> : null}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
